"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineSeriesPrefix = exports.determineSeasonNumberFromSeriesPrefix = exports.determineSeasonNumber = exports.determineProgramTitle = exports.determineEpisodeNumber = void 0;
/**
 * Derives a searchable seriesPrefix from the 
 * given seriesPrefix of format [prefix]_[addtional info]
 * @param {string} seriesPrefix 
 * 
 * @returns {string} 
 */
const determineSeriesPrefix = seriesPrefix => {
  const underscoreIndex = seriesPrefix.indexOf('_');
  if (underscoreIndex === -1) return seriesPrefix;
  return seriesPrefix.slice(0, underscoreIndex);
};
/**
 * Derives the season number from the title_code of
 * the program
 * @param {object} program
 * @param {string} program.title_code
 * 
 * @returns {string}
 */
exports.determineSeriesPrefix = determineSeriesPrefix;
const determineSeasonNumber = program => {
  if (program !== null && program !== void 0 && program.season_number) return program.season_number;
  // find first numeric char in title_code 
  let startIndex;
  for (let i = 0; i < program.title_code.length; i++) {
    // get the index of the first numeric char
    if (!isNaN(Number.parseInt(program.title_code.charAt(i), 10))) {
      startIndex = i;
      break;
    }
  }
  let seasonEpStr = program.title_code.slice(startIndex);
  // if there's only a single digit for the season
  if (seasonEpStr.length === 3) return seasonEpStr.substring(0, 1);
  return seasonEpStr.substring(0, 2);
};
/**
 * 
 * @param {object} program
 * @param {string} program.series_prefix 
 * 
 * @returns {string}
 */
exports.determineSeasonNumber = determineSeasonNumber;
const determineSeasonNumberFromSeriesPrefix = program => {
  if (program !== null && program !== void 0 && program.season_number) return program.season_number;
  const underscoreIndex = program.series_prefix.indexOf('_');
  return program.series_prefix.slice(underscoreIndex + 2 - program.series_prefix.length);
};
/**
 * Derives the episode number from the title_code of
 * the program
 * @param {object} program 
 * @param {string} program.title_code
 *  
 * @returns {string}
 */
exports.determineSeasonNumberFromSeriesPrefix = determineSeasonNumberFromSeriesPrefix;
const determineEpisodeNumber = program => {
  if (program !== null && program !== void 0 && program.episode_number) return program.episode_number;
  return program.title_code.slice(-4).substring(2);
};
/**
 * 
 * @param {object} program
 * @param {string} program.program
 *  
 * @returns {string} 
 */
exports.determineEpisodeNumber = determineEpisodeNumber;
const determineProgramTitle = program => {
  let startIndex = program.program.length;
  for (let i = program.program.length - 1; i >= program.program.length - 4; i--) {
    // get the index of the first numeric char
    if (program.program.charAt(i) === 'S') {
      startIndex = i;
      break;
    }
  }
  return program.program.slice(0, startIndex).trim();
};
exports.determineProgramTitle = determineProgramTitle;